export default __webpack_public_path__ + "static/media/food_image.ff862b95.jpg";